var module = angular.module('octopusApp.master');

module.directive('mainNavigationBar', function() {

    return {
        restrict: 'E',
        replace: true,
        transclude: false,
        templateUrl: 'areas/master/views/main_navigation_bar.html',
        link: function(scope, element) {
    },
        controller: function ($scope, $rootScope, octopusAuthenticator, octopusRepository, pollLoop, octopusClient) {
            $scope.tab = 'dashboard';
            $scope.isAuthenticated = false;
            $scope.searchEnabled = true;
            $scope.hasProjects = false;
            $scope.projectMenuItems = null;
            $scope.showUpgradeBullhorn = false;

            var root = $scope.rootDocument = octopusClient.rootDocument();

            $scope.canChangePassword = function() {
                return $rootScope.currentUser && $rootScope.currentUser.CanPasswordBeEdited && root.AnyAuthenticationProvidersSupportPasswordManagement;
            };

            var refreshProjects = function() {
                return octopusRepository.Dashboards.getDashboard().then(function(dashboardData) {
                    $scope.hasProjects = false;
                    var projectGroups = _.sortBy(dashboardData.ProjectGroups, function (p) { return p.Name.toLowerCase(); });

                    var projectsByGroup = { };
                    _.each(projectGroups, function (pg) {
                        projectsByGroup[pg.Id] = [];
                    });

                    _.each(_.sortBy(dashboardData.Projects, function (p) { return p.Name.toLowerCase(); }), function(project) {
                        projectsByGroup[project.ProjectGroupId].push(project);
                        $scope.hasProjects = true;
                    });

                    var allItems = [];
                    var order = 0;
                    _.each(projectGroups, function (pg) {
                        order++;
                        allItems.push( { Id: pg.Id, Order: order, Name: pg.Name, Slug: null });
                        _.each(projectsByGroup[pg.Id], function (project) {
                            order++;
                            allItems.push( { Id: project.Id, Order: order, Name: project.Name, Slug: project.Slug });
                        });
                    });

                    $scope.projectMenuItems = allItems;
                });
            };

            $scope.beginRefreshProjects = function() {
                refreshProjects();
            };

            octopusRepository.ServerStatus.getServerStatus().then(function(status) {

                $scope.isUpgradeAvailable = status.IsUpgradeAvailable;
                $scope.isMajorMinorUpgrade = status.IsMajorMinorUpgrade;

                if (status.IsUpgradeAvailable) {
                    $scope.maximumAvailableVersion = status.MaximumAvailableVersion;
                    if (status.MaximumAvailableVersion === status.MaximumAvailableVersionCoveredByLicense) {
                        $scope.canUpgradeFreeOfCharge = true;
                    } else {
                        $scope.canUpgradeFreeOfCharge = false;
                        $scope.maximumAvailableVersionCoveredByLicense = status.MaximumAvailableVersionCoveredByLicense;
                        $scope.maintenanceExpires = status.MaintenanceExpires;
                    }

                    // Check if we should show the upgrade bullhorn.
                    octopusRepository.UpgradeConfiguration.get().then(function (config) {
                        if (config.NotificationMode === 'AlwaysShow') {
                            $scope.showUpgradeBullhorn = true;
                        } else if (config.NotificationMode === 'ShowOnlyMajorMinor' && $scope.isMajorMinorUpgrade) {
                            $scope.showUpgradeBullhorn = true;
                        }
                    });
                }
            });

            var loop = pollLoop.create($scope, function() {
                return refreshProjects();
            }, 60000);

            loop.startImmediately();
        }
    };
});







//////////////////
// WEBPACK FOOTER
// ./app/areas/master/directives/main_navigation_bar.js
// module id = 476
// module chunks = 1